"use client";

import clsx from "clsx";
import type React from "react";
import {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

interface GailThinkingWordsProps {
   className?: string;
   intervalMs?: number;
}

const GailThinkingWords: React.FC<GailThinkingWordsProps> = ({
   className,
   intervalMs = 3000,
}) => {
   const {t, i18n} = useTranslation("ask");

   const words = useMemo(() => {
      const fromI18n = t("thinkingWords", {returnObjects: true});
      return Array.isArray(fromI18n) ? (fromI18n as string[]) : [];
   }, [t, i18n.resolvedLanguage]);

   const [index, setIndex] = useState(0);

   useEffect(() => {
      if (words.length <= 1) return;
      const id = setInterval(() => {
         setIndex((prev) => (prev + 1) % words.length);
      }, intervalMs);
      return () => clearInterval(id);
   }, [words, intervalMs]);

   if (words.length === 0) return null;

   const word = words[index % words.length];

   // Shimmer and fade live on separate elements: one element can only run a single animation at a time.
   return (
      <span className={clsx("inline-block text-sm text-500", className)}>
         <span key={index} className="inline-block animate-fade-in">
            <span className="animate-text-shimmer">{word}</span>
         </span>
      </span>
   );
};

export default GailThinkingWords;
